module.exports = __webpack_public_path__ + "components/flag/static/square/br-c2fb3006358949feaa22b8901afabd53.svg";